import { useNavigate } from "react-router-dom";
import { HeadphonesIcon, KeyRound, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/site";

const points = [
  { icon: HeadphonesIcon, label: "Assistenza dedicata" },
  { icon: KeyRound, label: "Check-in semplice" },
  { icon: BadgeCheck, label: "Strutture selezionate" },
];

export default function About() {
  const navigate = useNavigate();
  return (
    <section id="chi-siamo" className="py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <img
            src="/images/properties/la-terra-di-gaia/terra-di-gaia-vista-villa-giardino.webp"
            alt="La Terra di Gaia: la villa e il giardino con vista sul paesaggio abruzzese"
            loading="lazy"
            className="w-full h-[420px] md:h-[560px] object-cover rounded-2xl"
          />
        </Reveal>
        <Reveal className="order-1 lg:order-2" delay={100}>
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">Martelli Rentals</p>
          <h2 className="font-heading font-light text-3xl md:text-5xl leading-tight text-brand-black">
            Una selezione di dimore gestite con attenzione personale.
          </h2>
          <div className="mt-6 space-y-4 text-brand-brown leading-relaxed">
            <p>Martelli Rentals nasce per riunire strutture diverse, accomunate dalla stessa idea di ospitalità: ambienti curati, comunicazione semplice, assistenza presente e un rapporto diretto con ogni ospite.</p>
            <p>Dalle dimore nel centro storico dell’Aquila alle ville con piscina ai piedi del Monte Velino, fino agli appartamenti nelle principali città italiane, ogni soggiorno viene seguito con attenzione prima, durante e dopo l’arrivo.</p>
          </div>
          <div className="mt-8 grid grid-cols-3 gap-4">
            {points.map(({ icon: Icon, label }) => (
              <div key={label} className="flex flex-col items-start gap-2">
                <Icon className="w-6 h-6 text-brand-sage" />
                <span className="text-sm font-medium text-brand-black">{label}</span>
              </div>
            ))}
          </div>
          <button
            data-testid="about-cta"
            onClick={() => navigate("/chi-siamo")}
            className="mt-9 inline-flex border border-brand-olive text-brand-olive hover:bg-brand-olive hover:text-white transition-colors rounded-full px-7 py-3 font-medium"
          >
            Conosci Martelli Rentals
          </button>
        </Reveal>
      </div>
    </section>
  );
}
